import qs from 'query-string';

import appSettings from 'wanderu-config';
import { selectLocale } from 'wanderu-i18n';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import { OrdersService, TixService } from 'wanderu-service-wapi';

import { POLL_STATUS_DELAY_MS } from '../../../constants';
import {
    actions as bookingActions,
    selectors as bookingSelectors,
} from '../../appstate';
import { mapPollingStatus } from '../../appstate/utils';
import { pollEndpoint } from '../utils';
import {
    actions,
    namespace,
    reducer,
    selectors,
} from './base';
import { selectors as ordersSelectors } from '../../ordersSlice';

const logger = Logger.getLogger('wanderu-app-booking:pollInsuranceStatus');

function pollInsuranceStatus(insuranceProcessingId) {
    return async (dispatch, getState) => {
        dispatch(actions.startWork(insuranceProcessingId));

        let error;
        let meta;
        try {
            const locale = selectLocale(getState());
            const {
                itineraryId,
                bookingSessionId,
            } = bookingSelectors.selectBookingInfo(getState());

            const queries = {
                booking_session_id: bookingSessionId,
                itinerary_id: itineraryId,
                locale,
                processing_id: insuranceProcessingId,
            };

            const fetchFn = async () => {
                const { orderId } = ordersSelectors.selectOrderId(getState());

                let Service = TixService;
                let url = `v4/book/status?${qs.stringify(queries)}`;

                if (orderId) {
                    Service = OrdersService;
                    url = `wtix/v4/book/status?${qs.stringify({ ...queries, orderId })}`;
                }

                const { result } = await Service.get(url);

                const status = mapPollingStatus(result);

                await dispatch(bookingActions.setInsuranceStatus(result));

                if (!status.isQueued && !status.isProcessing) {
                    const property = {
                        booking_session_id: bookingSessionId,
                        insurance_processing_id: insuranceProcessingId,
                        itinerary_id: itineraryId,
                        status: result,
                    };
                    SnowplowService.fireStructuredEvent({
                        action: 'insurance_purchase',
                        category: 'checkout',
                        property: JSON.stringify(property),
                    });
                }
            };

            const shouldContinue = () => {
                const status = bookingSelectors.selectInsuranceStatus(getState());
                return status.isQueued || status.isProcessing;
            };

            await pollEndpoint(fetchFn, shouldContinue, POLL_STATUS_DELAY_MS);
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            error = ex?.responseBody?.error;

            logger.error('pollInsuranceStatus', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });
            throw ex;
        } finally {
            dispatch(actions.endWork(insuranceProcessingId, meta, error));
        }
    };
}

const pollInsuranceStatusAction = {
    poll: pollInsuranceStatus,
    ...selectors,
    ...actions,
};

export {
    pollInsuranceStatusAction,
};

export default {
    [namespace]: reducer,
};
